<button class="header-action-btn" aria-label="Open Chat" (click)="openModal()" type="button" title="Chat">
  <i class="far fa-comment-dots" aria-hidden="true"></i>
  <span class="badge-count" *ngIf="(presenceService.totalUncount | async) > 0">
    {{presenceService.totalUncount | async}}
  </span>
</button>

<div class="modal" id="chat" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">

    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
            <div cdkDragHandle class="modal-header" style="padding: 0.625rem;">
                <h6 class="modal-title" id="myModalLabel" name="myModalLabel">Chat</h6>
                <span style="margin-left: auto;margin-right: auto;font-weight: 900;font-size: 0.875rem;">
                    <img  alt="img" onerror="this.onerror=null;this.src='assets/images/default-user.png';" style="width: 1.5625rem; height: 1.5625rem; border: 1px solid #dddd; border-radius: 50%;font-size: 0.8125rem;" [src]="currentUserUrl">
                    {{currentUser.FullName}}
                </span>
                <button type="button" (click)="onCloseChat()" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"><i class="far text-black fa-times-circle"></i></span>
                </button>
            </div>
            <div class="modal-body text-left">
                <div class="row main-container m-0" [ngClass]="(!!messageService.otherUser && !!ApplicationId) ? 'chat-active' : 'chat-inactive'">
                    <!-- For Employee  -->
                    <div class="col-6 col-md-3 chat-column employee-col">

                        <div class="chat-search-box my-2 w-100" >
                            <input type="text" class="form-control form-control-sm rounded m-0 p-0" 
                                style="border: 0;width:100%;height:2.25rem" placeholder="Search" [(ngModel)]="nameSearch">

                        </div>
                        <div class="list d-flex overflow-auto " style="flex-direction:column;">
                            <div class="card my-1 shadow-sm employee-card"
                                [ngClass]="(messageService?.otherUser?.EmpId===Emp.EmpId)?'activecrd':''"
                                *ngFor="let Emp of (allEmpDetails|search:'EmpName':nameSearch)"
                                (click)="setOtherUser(Emp)">
                                <div class="card-body p-2 d-flex align-items-center justify-content-between">
                                    <span class="emp-name text-truncate mr-2">{{Emp.EmpName || Emp.Emp_Name || Emp.FullName || Emp.Name || Emp.username || ('Employee ' + Emp.EmpId)}}</span>
                                    <div class="d-flex align-items-center flex-shrink-0">
                                        <span *ngIf="(presenceService.onlineUser|async).includes(Emp.EmpId)" class="mr-1">
                                            <i class="fa fa-circle" style="color:rgb(53 195 10); font-size: 0.5625rem;"></i>
                                        </span>
                                        <span *ngIf="Emp.UnRead_Chat_Count>0" class="badge badge-success font-weight-bold">
                                            {{Emp.UnRead_Chat_Count}}
                                        </span>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                    <!-- FOr Application Id -->
                    <div class="col-6 col-md-4 chat-column application-col">

                        <div class="chat-search-box my-2 w-100">
                            <input *ngIf="showAppAddIcon" type="text" class="form-control"
                                style="border: 0;width:85%; margin-right: 0.3125rem;" placeholder="Search" [(ngModel)]="applicationIdSearch">
                            <input *ngIf="!showAppAddIcon" type="text" class="form-control form-control-sm rounded m-0 p-0 h-100"
                                style="border: 0;width:75%; margin-right: 0.3125rem;"  placeholder="Search"
                                [(ngModel)]="newAppSearch">
                            <i *ngIf="!showAppAddIcon" class="btn btn btn-transparent p-0 fa fa-times-circle h-100" 
                                style="color:white;padding-top:0.5rem !important" (click)="changeIconStatus()"></i>
                            <i class="btn btn-transparent p-0 h-100" 
                                [ngClass]="showAppAddIcon?'fa fa-plus':'fa fa-search '" style="color:var(--theme-primary, #007bff);padding-top:0.5rem !important"
                                (click)="showAppAddIcon?changeIconStatus():SearchApplication()"></i>
                        </div>
                        <div class="list d-flex overflow-auto" style="flex-direction:column;flex-grow: 1;">
                            <div class="card my-1 shadow-sm app-card"
                                [ngClass]="(ApplicationId===Apj.Application_No)?'activecrd':''"
                                *ngFor="let Apj of (applicationDetail|search:'Application_No':applicationIdSearch)"
                                (click)="setApplication(Apj)">
                                <div class="card-body p-2 d-flex flex-column justify-content-center">
                                    <div class="d-flex align-items-center justify-content-between w-100">
                                        <span class="app-no font-weight-bold text-dark text-truncate">
                                            {{Apj.Application_No}}<span *ngIf="Apj.LoanAcNo" class="text-secondary">/{{Apj.LoanAcNo}}</span>
                                        </span>
                                        <span *ngIf="Apj.UnReadCount>0" class="badge badge-success font-weight-bold ml-1">
                                            {{Apj.UnReadCount}}
                                        </span>
                                    </div>
                                    <div *ngIf="Apj.CustomerName" class="customer-name text-muted small mt-1 text-truncate">
                                        <i class="fa fa-user mr-1 text-primary"></i>{{Apj.CustomerName}}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <!-- For Messages -->
                    <div class="col-12 col-md-5 chat-column message-col"
                        *ngIf="!!messageService.otherUser && !!ApplicationId">

                        <div class="name-header w-100">
                            <section class="d-flex justify-content-between align-items-center">
                                <div class="d-flex align-items-center">
                                    <button type="button" class="back-to-list-btn mr-2" (click)="onBackToList()" aria-label="Back to chat list" title="Back">
                                        <i class="fa fa-arrow-left"></i>
                                    </button>
                                    <span>{{messageService.otherUser?.EmpName}} ({{ApplicationId}})
                                        <span
                                            *ngIf="(presenceService.onlineUser|async).includes(messageService.otherUser?.EmpId)"><i
                                                class="fa fa-circle fa-sm " style="color:rgb(53 195 10);font-size:0.5625rem"></i></span>
                                    </span>
                                </div>
                            </section>
                        </div>
                        <div class="message-box overflow-auto" style="flex-grow: 1;" #scroll [appScrollToBottom]="scroll">
                            <div class="messagecont">
                                <ng-container *ngFor="let message of (messageService.messageThreadSource.asObservable()|async)">
                                    <div class="chat-bubble-container" [ngClass]="(currentUser?.userId === message?.senderId) ? 'sent' : 'received'">
                                        <div class="chat-bubble" [ngClass]="(currentUser?.userId === message?.senderId) ? 'sent' : 'received'">
                                            <div *ngIf="!!message.document_Attachment" class="attachment-card">
                                                <a target="_blank" href="{{ docBaseUrl }}{{ ApplicationId}}/{{message.document_Attachment}}">
                                                    <img src="assets/images/Doc_Image.jpg" style="width:1.5rem;height:1.5rem;"> 
                                                    <i class="fa fa-download mx-1"></i>
                                                    <span>{{message.document_Attachment}}</span>
                                                </a>
                                            </div>
                                            <div class="text-content">
                                                {{message.msg}}
                                            </div>
                                            <span class="chat-time">{{message.sendDate}}</span>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>

                            <!-- send bar -->
                            <div class="sendmsg border-top p-2 bg-white d-flex align-items-center gap-2" id="flexmsg" #flexmsg>
                                <form #messageForm="ngForm" id="sndmsg" autocomplete="off" (ngSubmit)="sendMessage()" class="d-flex align-items-center w-100 m-0">
                                    <div class="input-group flex-grow-1 align-items-center rounded-pill bg-light border px-2 py-1 mr-2" style="background-color: #f1f5f9 !important;">
                                        <textarea cdkTextareaAutosize #msgbox form id="sndmsgbx" type="text" class="form-control border-0 bg-transparent py-1 shadow-none"
                                            pattern="[\W]*[\w\.]+[\w\W]*" name="message" [(ngModel)]="message"
                                            placeholder="Enter Message..." required rows="1"
                                            style="resize: none; outline: none; font-size: 0.875rem;" (keydown)="onKeydownMain($event)" (input)="autoGrow()"></textarea>
                                        
                                        <label for="attach" class="btn btn-link text-secondary m-0 p-1 cursor-pointer" title="Attach file">
                                            <i class="fa fa-paperclip" style="font-size: 1.125rem;"></i>
                                        </label>
                                        <input type="file" hidden id="attach" #attachbtn (change)="onAttachementChange($event)">
                                    </div>

                                    <button type="submit" class="btn btn-primary rounded-circle d-flex align-items-center justify-content-center p-0 flex-shrink-0"
                                        style="width: 2.25rem; height: 2.25rem;" [disabled]="messageForm.invalid" title="Send Message">
                                        <i class="fa fa-paper-plane text-white" style="font-size: 0.875rem;"></i>
                                    </button>
                                </form>
                            </div>
                        </div>

                    </div>

                    <!-- For User Profile -->
                    <div *ngIf="!!messageService.otherUser && !!!ApplicationId"
                        class="col-12 col-md-5 chat-column message-col user-profile-col d-none d-md-flex justify-content-center align-items-center">
                        <div id="viewProfile" class="d-flex flex-column align-items-center text-center p-4">
                            <div class="profile-img-container mb-3">
                                <img [src]="EmployeeDetails?.Emp_Image" onerror="this.src='assets/images/default-user.png';"
                                    class="profile-avatar shadow-sm" alt="User Avatar">
                            </div>
                            <h4 class="font-weight-bold mb-1 text-dark">
                                {{EmployeeDetails?.Employee_Name}}
                            </h4>
                            <p class="text-muted mb-3 font-weight-medium">
                                {{EmployeeDetails?.Role_Name}} <span *ngIf="EmployeeDetails?.Emp_code">({{EmployeeDetails?.Emp_code}})</span>
                            </p>
                            
                            <div class="contact-info d-flex flex-column gap-2 text-secondary">
                                <a href="mailto:{{EmployeeDetails?.Emp_Email}}" class="d-flex align-items-center justify-content-center text-decoration-none">
                                    <i class="fa fa-envelope mr-2"></i> {{EmployeeDetails?.Emp_Email}}
                                </a>
                                <div class="d-flex justify-content-center gap-3 mt-2" *ngIf="EmployeeDetails?.Mobile_No || EmployeeDetails?.Alternet_No">
                                    <span *ngIf="EmployeeDetails?.Mobile_No"><i class="fa fa-phone mr-1"></i> {{EmployeeDetails?.Mobile_No}}</span>
                                    <span *ngIf="EmployeeDetails?.Alternet_No"><i class="fa fa-phone mr-1"></i> {{EmployeeDetails?.Alternet_No}}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div *ngIf="Attachement" id="Attachement" class=" mx-1 " style="flex-direction: column;z-index: 4;">
                    <div class="modal-header p-0">
                        <span class="pull-right btn float right" (click)="onCloseAttachement()">x</span>
                    </div>
                    <div class="frame-content p-0 " style="overflow-x:auto;overflow-y: auto;">
                        <iframe style="width:100%;height:100%"  name="AttachDoc" title="Attac" [src]="sanitizer.bypassSecurityTrustResourceUrl(AttachementDisplay)" frameborder="0">

                        </iframe>
                    </div>
                    <div class="text-center font-weight-bold my-2">
                        {{Attachement.name}}
                    </div>
                    <div class="sendmsg d-flex m-1" style="flex-direction: row;">

                        <span class="bg-whitesmoke m-0 p-0" style="width: 80%;">
                            <form #AttachForm="ngForm"  autocomplete="off"
                                 class="h-100">
                                <input form  type="text" class="form-control h-100  mx-1" 
                                    pattern="[\W]*[\w\.]+[\w\W]*" name="AttachmentMsg" [(ngModel)]="AttachmentMsg"
                                    placeholder="Enter Message" >
                            </form>
                        </span>
                        <span class=" m-0 p-0 float-right" style="width: 10%;">
                            <i (click)="sendAttachement()" class="fa fa-paper-plane col-md-1 mx-1 btn"></i></span>


                    </div>
                </div>


            </div>

        </div>
    </div>
</div>